import { render, staticRenderFns } from "./LocationStatistic.vue?vue&type=template&id=c33c8260&"
import script from "./LocationStatistic.vue?vue&type=script&lang=js&"
export * from "./LocationStatistic.vue?vue&type=script&lang=js&"
import style0 from "./LocationStatistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/statistics/LocationStatistic.vue
// module id = null
// module chunks = 